<div class="product-section-box mt-0">
  <ul
    ngbNav
    #nav="ngbNav"
    [(activeId)]="active"
    class="nav nav-tabs custom-nav"
  >
    <li *ngFor="let tab of displayTag; let i = index"
        [ngbNavItem]="tab.name">

      <a ngbNavLink *ngIf="tab.display">
        <h3>{{ tab.name | translate }}</h3>
      </a>

      <ng-template ngbNavContent>
        <div class="product-description">

          <div
            class="nav-desh ckeditor-content"
            [class.collapsed]="!showMore[i] && (tab.value?.length ?? 0) > 600"
            [innerHTML]="decodeHtml(tab.value)">
          </div>

          <span
            *ngIf="(tab.value?.length ?? 0) > 600"
            class="show-more"
            (click)="showMore[i] = !showMore[i]">
            {{ showMore[i] ? 'Thu gọn' : 'Xem thêm' }}
          </span>

        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="custom-tab"></div>
</div>
